export default __webpack_public_path__ + "static/media/reciflixor.2ce62efe.png";